// This file contains all Amplify config for all environments

const devAwsMobile = {
  aws_project_region: 'us-east-2',
  aws_cognito_identity_pool_id: 'us-east-2:86e96add-2ed8-4a65-8694-90acc6cd8d60',
  aws_cognito_region: 'us-east-2',
  aws_user_pools_id: 'us-east-2_6UU3ojjUq',
  aws_user_pools_web_client_id: '72or7bhe5uqut9sm6hogdhdn0u',
  oauth: { domain: 'minesight-dev.auth.us-east-2.amazoncognito.com' },
  aws_cognito_username_attributes: ['EMAIL'],
  aws_cognito_social_providers: [],
  aws_cognito_signup_attributes: ['EMAIL'],
  aws_cognito_mfa_configuration: 'OPTIONAL',
  aws_cognito_mfa_types: ['TOTP'],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: 8,
    passwordPolicyCharacters: [
      'REQUIRES_LOWERCASE',
      'REQUIRES_UPPERCASE',
      'REQUIRES_NUMBERS',
      'REQUIRES_SYMBOLS',
    ],
  },
  aws_cognito_verification_mechanisms: ['EMAIL'],
  aws_user_files_s3_bucket: 'minesightborer489fc8a0deb24b949d89a80e93dc9b6281655-dev',
  aws_user_files_s3_bucket_region: 'us-east-2',
};

const stagingAwsMobile = {
  aws_project_region: 'us-east-2',
  aws_cognito_identity_pool_id: 'us-east-2:c4d9e531-b3af-4cb0-acb2-4668bd609656',
  aws_cognito_region: 'us-east-2',
  aws_user_pools_id: 'us-east-2_PbsW1Jhsc',
  aws_user_pools_web_client_id: '6ev25nhqdbv5rq6rkku93pgb65',
  oauth: {
    domain: 'minesight-stage.auth.us-east-2.amazoncognito.com',
  },
  aws_cognito_username_attributes: [],
  aws_cognito_social_providers: [],
  aws_cognito_signup_attributes: ['EMAIL'],
  aws_cognito_mfa_configuration: 'OFF',
  aws_cognito_mfa_types: [],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: 8,
    passwordPolicyCharacters: [
      'REQUIRES_LOWERCASE',
      'REQUIRES_UPPERCASE',
      'REQUIRES_NUMBERS',
      'REQUIRES_SYMBOLS',
    ],
  },
  aws_cognito_verification_mechanisms: ['EMAIL'],
  aws_user_files_s3_bucket: 'minesightborer489fc8a0deb24b949d89a80e93dc9b62133602-stage',
  aws_user_files_s3_bucket_region: 'us-east-2',
};

const uatAwsMobile = {
  aws_project_region: 'us-east-2',
  aws_cognito_identity_pool_id: 'us-east-2:4ef5e267-9346-4dfa-83dc-4090b0526367',
  aws_cognito_region: 'us-east-2',
  aws_user_pools_id: 'us-east-2_7Az4n4x1Y',
  aws_user_pools_web_client_id: '54phfp0806mc9o9v3g7s570kkn',
  oauth: {
    domain: 'minesight-uat.auth.us-east-2.amazoncognito.com',
    scope: ['aws.cognito.signin.user.admin', 'email', 'openid', 'phone', 'profile'],
    redirectSignIn:
      'http://localhost:9000,http://localhost:9000/login,https://uat.minesight.nutrien.com/login,https://uat2.minesight.nutrien.com/login',
    redirectSignOut:
      'http://localhost:9000,http://localhost:9000/login,https://uat.minesight.nutrien.com/login,https://uat2.minesight.nutrien.com/login',
    responseType: 'code',
  },
  federationTarget: 'COGNITO_USER_POOLS',
  aws_cognito_username_attributes: [],
  aws_cognito_social_providers: [],
  aws_cognito_signup_attributes: ['EMAIL'],
  aws_cognito_mfa_configuration: 'OFF',
  aws_cognito_mfa_types: [],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: 8,
    passwordPolicyCharacters: [
      'REQUIRES_LOWERCASE',
      'REQUIRES_UPPERCASE',
      'REQUIRES_NUMBERS',
      'REQUIRES_SYMBOLS',
    ],
  },
  aws_cognito_verification_mechanisms: ['EMAIL'],
  aws_user_files_s3_bucket: 'minesightborer489fc8a0deb24b949d89a80e93dc9b62121433-uat',
  aws_user_files_s3_bucket_region: 'us-east-2',
};

const trainingAwsmobile = {
  aws_project_region: 'us-east-2',
  aws_cognito_identity_pool_id: 'us-east-2:04eeb929-b5eb-43fd-88f2-0512a3df7acf',
  aws_cognito_region: 'us-east-2',
  aws_user_pools_id: 'us-east-2_87gtmPVdU',
  aws_user_pools_web_client_id: '1bk2vo9mltqcubccmj5e9v8eak',
  oauth: {
    domain: 'minesight-training.auth.us-east-2.amazoncognito.com',
    scope: ['aws.cognito.signin.user.admin', 'email', 'openid', 'phone', 'profile'],
    redirectSignIn: 'https://training.minesight.nutrien.com/login',
    redirectSignOut: 'https://training.minesight.nutrien.com/login',
    responseType: 'code',
  },
  federationTarget: 'COGNITO_USER_POOLS',
  aws_cognito_username_attributes: [],
  aws_cognito_social_providers: [],
  aws_cognito_signup_attributes: ['EMAIL'],
  aws_cognito_mfa_configuration: 'OFF',
  aws_cognito_mfa_types: [],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: 8,
    passwordPolicyCharacters: [
      'REQUIRES_LOWERCASE',
      'REQUIRES_UPPERCASE',
      'REQUIRES_NUMBERS',
      'REQUIRES_SYMBOLS',
    ],
  },
  aws_cognito_verification_mechanisms: ['EMAIL'],
  aws_user_files_s3_bucket: 'minesightborer489fc8a0deb24b949d89a80e93dc9b62111900-training',
  aws_user_files_s3_bucket_region: 'us-east-2',
};

const rcAwsmobile = {
  // Same as stage
  aws_project_region: 'us-east-2',
  aws_cognito_identity_pool_id: 'us-east-2:c4d9e531-b3af-4cb0-acb2-4668bd609656',
  aws_cognito_region: 'us-east-2',
  aws_user_pools_id: 'us-east-2_PbsW1Jhsc',
  aws_user_pools_web_client_id: '6ev25nhqdbv5rq6rkku93pgb65',
  oauth: { domain: 'minesight-stage.auth.us-east-2.amazoncognito.com' },
  aws_cognito_username_attributes: [],
  aws_cognito_social_providers: [],
  aws_cognito_signup_attributes: ['EMAIL'],
  aws_cognito_mfa_configuration: 'OFF',
  aws_cognito_mfa_types: [],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: 8,
    passwordPolicyCharacters: [
      'REQUIRES_LOWERCASE',
      'REQUIRES_UPPERCASE',
      'REQUIRES_NUMBERS',
      'REQUIRES_SYMBOLS',
    ],
  },
  aws_cognito_verification_mechanisms: ['EMAIL'],
  aws_user_files_s3_bucket: 'minesightborer489fc8a0deb24b949d89a80e93dc9b62133602-stage',
  aws_user_files_s3_bucket_region: 'us-east-2',
};

const prodAwsMobile = {
  aws_project_region: 'us-east-2',
  aws_cognito_identity_pool_id: 'us-east-2:16895874-c37c-4e27-92b7-b921c572b8b6',
  aws_cognito_region: 'us-east-2',
  aws_user_pools_id: 'us-east-2_jumkUd4Fz',
  aws_user_pools_web_client_id: '4632gk1sre8bv57fugc2leilot',
  oauth: { domain: 'minesight-prod.auth.us-east-2.amazoncognito.com' },
  aws_cognito_username_attributes: [],
  aws_cognito_social_providers: [],
  aws_cognito_signup_attributes: ['EMAIL'],
  aws_cognito_mfa_configuration: 'OFF',
  aws_cognito_mfa_types: [],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: 8,
    passwordPolicyCharacters: [
      'REQUIRES_LOWERCASE',
      'REQUIRES_UPPERCASE',
      'REQUIRES_NUMBERS',
      'REQUIRES_SYMBOLS',
    ],
  },
  aws_cognito_verification_mechanisms: ['EMAIL'],
  aws_user_files_s3_bucket: 'minesightborer489fc8a0deb24b949d89a80e93dc9b62175228-prod',
  aws_user_files_s3_bucket_region: 'us-east-2',
};

export const environments = ['dev', 'staging', 'uat', 'training', 'rc', 'prod'] as const;
type AppEnvironment = (typeof environments)[number];

const isAppEnvironment = (env: unknown): env is AppEnvironment => {
  return typeof env === 'string' && environments.some(environment => environment === env);
};

const awsMobileConfigs = {
  dev: devAwsMobile,
  staging: stagingAwsMobile,
  uat: uatAwsMobile,
  training: trainingAwsmobile,
  rc: rcAwsmobile,
  prod: prodAwsMobile,
};

export const getAwsExportsConfig = (env: unknown) => {
  if (!isAppEnvironment(env)) {
    throw new Error(`${env} is an invalid environment`);
  }
  return awsMobileConfigs[env];
};
